import script from "./BaseServiceFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseServiceFeatures.vue?vue&type=script&setup=true&lang=js"

import "./BaseServiceFeatures.vue?vue&type=style&index=0&id=f2c7d04c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2c7d04c"]])

export default __exports__